import React from "react";
import Hero from "./sections/Hero";
import AnnouncementTicker from "./sections/AnnouncementTicker";
import Stats from "./sections/Stats";
import CourtsShowcase from "./sections/CourtsShowcase";
import DuprShowcase from "./sections/DuprShowcase";
import EventsTeaser from "./sections/EventsTeaser";
import Coaches from "./sections/Coaches";
import Testimonials from "./sections/Testimonials";
import Contact from "./sections/Contact";

export default function Draft2Home() {
  return (
    <>
      <Hero />
      <AnnouncementTicker />
      <Stats />
      <CourtsShowcase />
      <DuprShowcase />
      <EventsTeaser />
      <Coaches />
      <Testimonials />
      <Contact />
    </>
  );
}
